import { g as i } from "./global.js";
var e = i.isFinite,
  n = Number.isFinite || function (i) {
    return "number" == typeof i && e(i);
  };
export { n };